var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import JetButton from '@/Jetstream/Button';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import ClientFormLayout from '../ClientFormLayout';
import ClientFormSteps from '../Partials/ClientFormSteps';
import useForm from "@/Utils/useForm";
import TravelStepFields from '@/Pages/Certificate/Steps/Partials/TravelStepFields';
import CertificateValidator from '@/lib/CertificateValidator';
import ValidationNote from '@/Jetstream/ValidationNote';
var ClientForm = function (_a) {
    var clientForm = _a.clientForm, branch = _a.branch, client = _a.client, countryOptions = _a.countryOptions, languageOptions = _a.languageOptions, certificate = _a.certificate;
    var route = useRoute(Ziggy);
    var firstFieldRef = React.useRef(null);
    var form = useForm(__assign({}, certificate));
    var validator = new CertificateValidator();
    var _b = useState(validator.validate({ id: 0 }, branch, form.data, [])), validation = _b[0], setValidation = _b[1];
    useEffect(function () {
        if (!form.data.transporter) {
            form.data.transporter = 'owner';
        }
        setValidation(validator.validate({ id: 0 }, branch, form.data, []));
        console.log('validation', validation);
    }, [form.data]);
    useEffect(function () {
        var _a;
        (_a = firstFieldRef === null || firstFieldRef === void 0 ? void 0 : firstFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [0]);
    var labels = {
        "Pets transported by": "Who is transporting your pets?",
        "Mode of travel": "How will you be travelling?",
        "Will the pet(s) be returning to the UK within 120 days?": "Will your pet(s) be returning to the UK within 120 days?",
        "First country": "First country of entry",
        "Final country": "Last EU country before returning to the UK",
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "border-b pb-6 mb-6" }, { children: _jsx(ClientFormSteps, { clientForm: clientForm, step: 2 }) })), _jsxs("div", __assign({ className: "sm:grid grid-cols-2 gap-6" }, { children: [_jsxs("div", __assign({ className: "space-y-6 mb-6" }, { children: [_jsx(TravelStepFields, { form: form, countryOptions: countryOptions, languageOptions: languageOptions, showFormLanguage: false, labels: labels }), _jsxs(JetButton, __assign({ disabled: form.processing, id: "continue", onClick: function () { return form.post(route('client-public-form.step-2.submit', { clientForm: clientForm })); }, className: "text-lg pr-2" }, { children: ["Continue ", _jsx(ChevronRightIcon, { className: "ml-2 h-5 w-5" })] }))] })), _jsx("div", __assign({ className: "p-6 bg-gray-50 rounded-lg shadow-inner text-gray-700" }, { children: Object.keys(validation.results).filter(function (key) { return [
                            "transporter",
                            "transporter_agent_name",
                            "transporter_carrier_company",
                            "date_of_entry",
                            "first_country",
                            "language",
                            "final_country",
                            "return_in_120d",
                            "mode_of_travel",
                            "transporter_letter"
                        ].indexOf(key) > -1; }).map(function (key) {
                            return _jsx(ValidationNote, { field: key, className: "mb-2", note: validation.results[key], showLink: false });
                        }) }))] }))] }));
};
ClientForm.layout = ClientFormLayout;
export default ClientForm;
